import React from "react";
import style from "css/template.module.css";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
/**import { Microsoft } from 'pages/menupages/microsoft';

 * Version : 1.0
 * 작성일자 : 2023-12-11
 * 작성자 : 권도훈
 * 설명 : 공통 템플릿 영역
 */
function Footer() {
  //navigate
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const menuHandler = (e) => {
    navigate(process.env.REACT_APP_CLIENT_URL + e);
  };
  const toblue = () => {
    window.open("https://bluetns.co.kr");
  };

  const submenucompany = (val) => {
    navigate(process.env.REACT_APP_CLIENT_URL + "company", {
      state: {
        title: val,
      },
    });
  };

  //반응형
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const check = useMediaQuery({ query: "(max-width: 1024px)" });

  return (
    <>
      {pathname.includes("admin") ? (
        <></>
      ) : (
        <div className={style.footer}>
          <div className={style.footer_content_wrap}>
            <div className={style.footer_left_area}>
              <div className={style.company_info_area}>
                <img
                  alt=""
                  src={
                    isMobile ? "/img/common/logo_m.png" : "/img/common/logo.png"
                  }
                />
                <div className={style.company_info}>
                  <div className={style.company_info_item}>
                    <div className={style.company_info_label}>Address</div>
                    <div className={style.company_info_value}>
                      {
                        "137-902 서울시 서초구 강남대로 101길 43\n유영빌딩 6층 (잠원동 9-4)"
                      }
                    </div>
                  </div>
                  <div className={style.company_info_item}>
                    <div className={style.company_info_label}>TEL</div>
                    <div className={style.company_info_value}>02-595-7782</div>
                  </div>

                  <div className={style.company_info_item}>
                    <div className={style.company_info_label}>
                      사업자등록번호
                    </div>
                    <div className={style.company_info_value}>114-86-93156</div>
                  </div>
                </div>

                {isMobile ? (
                  <div className={style.company_footer}>
                    <div className={style.icon_area}>
                      <img
                        onClick={() =>
                          window.open("https://blog.naver.com/softdoctor")
                        }
                        className="cursor"
                        alt=""
                        src={
                          check
                            ? "/img/common/blog_m.png"
                            : "/img/common/blog.png"
                        }
                      />
                      <img
                        className="cursor"
                        alt=""
                        src={
                          check
                            ? "/img/common/facebook_m.png"
                            : "/img/common/facebook.png"
                        }
                        onClick={() => {
                          window.open(
                            "https://www.facebook.com/people/%EC%86%8C%ED%94%84%ED%8A%B8%EB%8B%A5%ED%84%B0/100080180351449/"
                          );
                        }}
                      />

                      <img
                        onClick={() => {
                          window.open("https://www.youtube.com/@zwcadea5313");
                        }}
                        className="cursor"
                        alt=""
                        src={
                          check
                            ? "/img/common/youtube_m.png"
                            : "/img/common/youtube.png"
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className={style.icon_area}>
                    <img
                      onClick={() =>
                        window.open("https://blog.naver.com/softdoctor")
                      }
                      className="cursor"
                      alt=""
                      src="/img/common/blog.png"
                    />
                    <img
                      className="cursor"
                      alt=""
                      src="/img/common/facebook.png"
                      onClick={() => {
                        window.open(
                          "https://www.facebook.com/people/%EC%86%8C%ED%94%84%ED%8A%B8%EB%8B%A5%ED%84%B0/100080180351449/"
                        );
                      }}
                    />

                    <img
                      onClick={() => {
                        window.open("https://www.youtube.com/@zwcadea5313");
                      }}
                      className="cursor"
                      alt=""
                      src="/img/common/youtube.png"
                    />
                  </div>
                )}
              </div>

              {isMobile ? (
                <></>
              ) : (
                <div className={style.sitemap_area}>
                  <div className={style.menu_list_wrapper}>
                    <div className={style.menu_list}>
                      <div
                        className={style.menu_label}
                        onClick={() => menuHandler("CAD")}
                      >
                        ZWCAD
                      </div>
                      <div
                        className={style.menu_label}
                        onClick={() => menuHandler("Microsoft")}
                      >
                        Microsoft
                      </div>
                      <div
                        className={style.menu_label}
                        onClick={() => menuHandler("Adobe")}
                      >
                        Adobe
                      </div>
                      <div
                        className={style.menu_label}
                        onClick={() => menuHandler("Landering")}
                      >
                        랜더링
                      </div>
                      <div
                        className={style.menu_label}
                        onClick={() => menuHandler("Documents")}
                      >
                        문서/자산관리
                      </div>
                      <div
                        className={style.menu_label}
                        onClick={() => menuHandler("Security")}
                      >
                        보안 솔루션
                      </div>
                      <div
                        className={style.menu_label}
                        onClick={() => menuHandler("Announcement")}
                      >
                        고객센터
                      </div>
                    </div>
                  </div>

                  <div className={style.contact_menu_area}>
                    <div className={style.contact_menu}>
                      <div
                        className={`${style.contact_menu_item} cursor`}
                        onClick={() => toblue()}
                      >
                        블루티엔에스 바로가기
                      </div>
                      <div
                        className={`${style.contact_menu_item} cursor`}
                        onClick={() => menuHandler("free")}
                      >
                        무료체험 신청
                      </div>
                      <div
                        className={`${style.contact_menu_item} cursor`}
                        onClick={() => menuHandler("request")}
                      >
                        견적 신청
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {isMobile ? (
              <div className={style.contact_menu}>
                <div
                  className={`${style.contact_menu_item} cursor`}
                  onClick={() => toblue()}
                >
                  블루티엔에스 바로가기
                </div>
                <div
                  className={`${style.contact_menu_item} cursor`}
                  onClick={() => menuHandler("free")}
                >
                  무료체험
                </div>
                <div
                  className={`${style.contact_menu_item} cursor`}
                  onClick={() => menuHandler("request")}
                >
                  견적 신청
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className={style.copyright}>
            {isMobile
              ? "© 2024 SOFT DOCTOR. CO.,LTD.\nAll rights reserved."
              : "© 2024 SOFT DOCTOR. CO.,LTD. All rights reserved."}
          </div>
        </div>
      )}
    </>
  );
}

export default Footer;
